<template>
  <div>
    <Header2022 :navbg='true'></Header2022>
    <div class="content">
      <div class="banner">
        <img src="../../../assets/images/online-experience-banner.jpg" alt="">
      </div>

      <div class="crumbs">
        <div class="page">
          首页 / 线上体验
        </div>
      </div>
      <div class="online-wrap">
        <div class="page">
          <div class="title">我们很高兴能够为您提供居住方案</div>
          <div class="desc">臻选100-200㎡ 匠造精筑典范</div>
          <div class="online-list">
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/cloud/design/3FO4BTVSTL3G/show')">
              <div class="iconfont icon-icon-test1"></div>
              <div class="name">小院怡居A户型</div>
            </div>
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/cloud/design/3FO4BJ7SGGHK/show')">
              <div class="iconfont icon-icon-test"></div>
              <div class="name">小院怡居B户型</div>
            </div>
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/design/3FO4BJ7R1EEL/show')">
              <div class="iconfont icon-icon-test2"></div>
              <div class="name">小院怡居C1户型</div>
            </div>
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/cloud/design/3FO4BJBP4WK6/show')">
              <div class="iconfont icon-icon-test3"></div>
              <div class="name">小院怡居C2户型</div>
            </div>
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/design/3FO4BOTUU778/show')">
              <div class="iconfont icon-A"></div>
              <div class="name">小院怡居D1户型</div>
            </div>
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/cloud/design/3FO4GDFY660G/show')">
              <div class="iconfont icon-B"></div>
              <div class="name">小院怡居D2户型</div>
            </div>
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/design/3FO4B92PYYSN/show')">
              <div class="iconfont icon-icon-test2"></div>
              <div class="name">小院怡居E1户型</div>
            </div>
            <div class="item" @click="vrClick('https://pano8.p.kujiale.com/design/3FO4B92IYGK8/show')">
              <div class="iconfont icon-icon-test3"></div>
              <div class="name">小院怡居E2户型</div>
            </div>
          </div>
        </div>
      </div>

      <ContactUs></ContactUs>

    </div>
    <Footer2022></Footer2022>
  </div>
</template>

<script>
import Header2022 from '@/components/header2022.vue'
import Footer2022 from '@/components/footer2022.vue'

import ContactUs from '@/components/contact-us.vue'

export default {
  data () {
    return {

    }
  },
  components: {
    Header2022,
   	Footer2022,
    ContactUs,
  },
  methods:{
    vrClick(url){
      window.open(url)
    },
  },
}
</script>

<style lang="scss" scoped>
.content{
  padding-top: 64px;
  .banner{
    width: 100%;
    img{
      width: 100%;
    }
  }
  .crumbs{
    width: 100%;
    background-color: #F7F8F9;
    .page{
      width: 1200px;
      margin: auto;
      height: 62px;
      font-size: 12px;
      line-height: 62px;
    }
  }
  .online-wrap{
    width: 100%;
    background-color: #fff;
    .page{
      width: 1200px;
      margin: auto;
      padding: 89px 0 113px;
      .title{
        font-size: 20px;
        color: #707372;
        line-height: 20px;
        text-align: center;
      }
      .desc{
        font-size: 14px;
        color: #9D9D9D;
        line-height: 14px;
        text-align: center;
        margin-top: 34px;
      }
      .online-list{
        margin-top: 62px;
        display: flex;
        flex-wrap: wrap;
        // justify-content: center;
        .item{
          width: 170px;
          height: 170px;
          display: flex;
          margin: 20px 14px 0;
          flex-direction: column;
          border: 1px solid #707473;
          border-radius: 4px;
          justify-content: center;
          align-items: center;
          color: #707372;
          cursor: pointer;
          .iconfont{
            font-size: 58px;
          }
          .name{
            font-size: 15px;
            margin-top: 20px;
          }
          &:hover{
            background-color: #F7F8F9;
          }
        }
      }
    }
  }
}
</style>